import MenuHeader from "../../common/MenuHeader"
import RightGoogleMap from "../../common/RightGoogleMap"
import SetUpLayout from "../../common/SetUpLayout"
import LayoutMain from "./LayoutMain"

type Props = {}

const Sites = (props: Props) => {
  return (
    <SetUpLayout
      title='Sites'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMap style={{
        width: { xs: '488px' },
      }} />}
    >
      <LayoutMain title="Data 1 of 9" subtitle="Sites and Locations" />
    </SetUpLayout>
  )
}

export default Sites